import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getCompanyURL } from '../utilities/extensions'
import { apiURL } from '../utilities/URLs'
import { company } from '../utilities/CustomerData'

export default function SignUpModal() {
  const navigate = useNavigate('')

  const [signUpEmail, setSignUpEmail] = useState('')
  const [signUpLast4SSN, setSignUpLast4SSN] = useState('')
  const [signUpError, setSignUpError] = useState('')
  const [signUpLoading, setSignUpLoading] = useState('')

  const handleSignUp = async () => {
    if (signUpEmail.length > 0 && signUpLast4SSN.length > 0) {
      setSignUpLoading('Requesting Email...')
      const sendEmailResponse = await fetch(`${apiURL}/api/requestSignUpToken?email=${encodeURIComponent(signUpEmail.trim().toLocaleLowerCase())}&companyId=${encodeURIComponent(company.companyId)}&last4SSN=${encodeURIComponent(signUpLast4SSN)}`)
      const sendEmailData = await sendEmailResponse.json()

      if (sendEmailData.response.error) {
        if(sendEmailData.response.error === 'Wrong Company')
          window.location.href = `${getCompanyURL(sendEmailData.response.customerCompanyId)}?email=${encodeURIComponent(signUpEmail.trim())}&last4SSN=${encodeURIComponent(signUpLast4SSN)}`
        else {
          setSignUpLoading('')
          setSignUpError(sendEmailData.response.error)
        }
      } else
        navigate(`/signUp/${sendEmailData.response.signUpToken}`)
    } else {
      setSignUpError('Please Provide Both Email and SSN')
      setTimeout(() => {
        setSignUpError('')
      }, 2000)
    }
  }

  return (
    <div className='fixed inset-0 flex justify-center items-center z-50 font-mont'>
      <div className='fixed inset-0 bg-gray-800 bg-opacity-75 backdrop-blur-sm'></div>
      <div className='relative p-8 rounded-xl shadow-xl max-w-md w-full mx-4 sm:mx-auto bg-white'>
        <div className='w-full flex flex-col items-center'>
          <p className='font-bold text-3xl mb-2'>Create Account</p>
          <p className='text-center text-sm text-gray-500 mb-4'>It looks like you don’t have a portal account associated with your application. Let’s create one now.</p>

          <div className='w-full flex flex-col gap-4'>
            <input
              type='email'
              value={signUpEmail}
              onChange={(e) => setSignUpEmail(e.target.value)}
              placeholder='Email'
              className='border border-gray-300 rounded-lg px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500'
            />

            <input
              type='text'
              maxLength={4}
              value={signUpLast4SSN}
              onChange={(e) => setSignUpLast4SSN(e.target.value)}
              placeholder='Last 4 of SSN'
              className='border border-gray-300 rounded-lg px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500'
            />

            {signUpError && (
              <p className='text-red-600 text-sm font-semibold'>{signUpError}</p>
            )}

            <button
              onClick={handleSignUp}
              disabled={!!signUpLoading}
              className='bg-primaryColor text-white rounded-lg px-4 py-2 hover:bg-primaryDarkColor transition-all disabled:opacity-50'
            >
              {signUpLoading ? signUpLoading : 'Sign Up'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}